import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
// import { PATH_FACEBOOK_URL, PATH_INSTAGRAM_URL, ROOT_URL } from '../../constants/pathConstants'
import { PATH_FACEBOOK_URL, PATH_INSTAGRAM_URL } from '../../constants/pathConstants'
import { useState } from 'react'

function ContactUs() {

	const charCount: number = 250

	const [firstName, setFirstName] = useState<string>('')
	const [lastName, setLastName] = useState<string>('')
	const [email, setEmail] = useState<string>('')
	const [phone, setPhone] = useState<string>('')
	const [message, setMessage] = useState<string>('')

	const [sendingMessage, setSendingMessage] = useState<boolean>(false)
	const [messageSent, setMessageSent] = useState<boolean>(false)

	const signUpClicked = () => {
		// window.location.replace(ROOT_URL)
		setSendingMessage(true)
		setTimeout(() => {
			setSendingMessage(false)
			setMessageSent(true)
		}, 2000)
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='contact-us-content'>
						<div className='contact-us-info-wrap'>
							<div className='contact-us-info-content'>
								<div className='contact-us-info-title'>Contact Us</div>
								<div className='contact-us-info-sub-text'>Fill up the form and our Team will get back to you within 24 hours.</div>
								<table className='contact-us-info-details-table'>
									<tbody>
										{/* <tr>
											<td><img src='/imgs/icons/icon-contact-phone.svg' alt='phone'></img></td>
											<td>+44 20 7946 0958</td>
										</tr> */}
										<tr>
											<td><img src='/imgs/icons/icon-contact-email.svg' alt='email'></img></td>
											<td>info@skivio.co</td>
										</tr>
										{/* <tr>
											<td><img src='/imgs/icons/icon-contact-location.svg' alt='location'></img></td>
											<td>45 High Street,<br/>Suite 3 Manchester,<br/>M4 1FS UK</td>
										</tr> */}
									</tbody>
								</table>
								<div className='contact-us-info-social-wrap'>
									<a
										className='contact-us-info-social-link'
										href={PATH_FACEBOOK_URL}
										target='blank'
									>
										<img src='/imgs/icons/icon-contact-facebook.svg' alt='Facebook' />
									</a>
									{/* <img src='/imgs/icons/icon-contact-x.svg' alt='X' /> */}
									<a
										className='contact-us-info-social-link'
										href={PATH_INSTAGRAM_URL}
										target='blank'
									>
										<img src='/imgs/icons/icon-contact-instagram.svg' alt='Instagram' />
									</a>
								</div>
							</div>
						</div>
						<div className='contact-us-form'>
							{messageSent === true ? 
								<div className='contact-us-form-complete-message'>Message Sent, Thank you. We will get back to you as soon as possible</div>
								:
								<>
									<div className='contact-us-form-title'>Tell us about yourself.</div>
									<input 
										className='contact-us-form-input'
										placeholder={'First Name *'} 
										id='firstName' 
										value={firstName}
										onChange={(event) => {
											setFirstName(event.target.value)
										}}
										disabled={sendingMessage === true}
									/>
									<input 
										className='contact-us-form-input'
										placeholder={'Last Name *'}
										id='lastName' 
										value={lastName}
										onChange={(event) => {
											setLastName(event.target.value)
										}}
										disabled={sendingMessage === true}
									/>
									<input 
										className='contact-us-form-input' 
										type={'email'} 
										placeholder={'Email Address *'} 
										id='email' 
										value={email}
										onChange={(event) => {
											setEmail(event.target.value)
										}}
										disabled={sendingMessage === true}
									/>
									<input 
										className='contact-us-form-input' 
										placeholder={'Phone Number *'} 
										id='phone' 
										value={phone}
										onChange={(event) => {
											setPhone(event.target.value)
										}}
										disabled={sendingMessage === true}
									/>
									<div className='contact-us-form-title'>Select Your Role to Get Started</div>
									<div className='contact-us-form-radio-wrap'>
										<input type="radio" id="student" name="contactType" value="student" disabled={sendingMessage === true} />
										<label htmlFor="student">Student</label>
										<input type="radio" id="instructor" name="contactType" value="instructor" disabled={sendingMessage === true} />
										<label htmlFor="instructor">Instructor</label>
										<input type="radio" id="enquiry" name="contactType" value="enquiry" disabled={sendingMessage === true} defaultChecked={true} />
										<label htmlFor="enquiry">Enquiry</label>
									</div>
									<div className='contact-us-form-title'>Your Message</div>
									<textarea
										className='contact-us-form-input contact-us-form-input-text-area'
										// type='text-area'
										placeholder={`Write your message (max ${charCount} Characters)`}
										id='message'
										value={message}
										onChange={(event) => {
											// limit length to charCount characters
											if (event.target.value.length > charCount) {
												setMessage(event.target.value.substring(0, charCount))
											} else {
												setMessage(event.target.value)
											}
										}}
										disabled={sendingMessage === true}
									/>
									<CtaButton
										label={sendingMessage ? 'Sending...' : 'Send Message'}
										size='medium'
										onClick={() => signUpClicked()}
										fullWidth={true}
										disabled={
											firstName === '' || 
											lastName === '' || 
											phone === '' || 
											email === '' || 
											message === '' ||
											sendingMessage === true
										}
									/>
								</>
							}
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default ContactUs
